// app签约邀请

import fetch,{ postFrom } from '../utils/fetch';

// 个人签约邀请页面条件接口
export function getSignInviteInfo(stockFid) {
  return fetch({
      method: 'GET',
      url: 'signinvite/getSignInviteInfo',
      params : {
        stockFid
      }
  })
}

// 保存个人签约邀请记录
export function saveSignInviteInfo(data) {
  return fetch({
      method: 'POST',
      url: 'signinvite/saveSignInviteInfo',
      data
  })
}

//验证手机号
export function validSignInvite(phone,projectFid) {
  return fetch({
      method: 'GET',
      url: 'signinvite/validSignInvite',
      params : {
        phone,
        projectFid
      }
  })
}

